import { BaseComponent } from "utils/base-component"
import "./dropdown.scss"
import "./text-field.scss"
import "./toggle-search-mode.scss"

type SearchMode = "search" | "dropdown"

export class ToggleSearchMode extends BaseComponent {
  static cssClass = "location-search-toggle-search-mode"

  private hasEnabledAnimations = false
  private modeInputs!: HTMLInputElement[]
  private searchFieldContainer!: HTMLElement
  private dropdownContainer!: HTMLElement

  init() {
    this.modeInputs = this.elements("radio-input").map((item) => item.element) as HTMLInputElement[]
    this.searchFieldContainer = this.element("search-field-container")?.element as HTMLElement
    this.dropdownContainer = this.element("dropdown-container")?.element as HTMLElement

    if (this.modeInputs.length === 0 || !this.searchFieldContainer || !this.dropdownContainer)
      return

    this.modeInputs.forEach((input: HTMLInputElement) => {
      input.addEventListener("change", () => {
        if (!input.checked) return

        if (!this.hasEnabledAnimations) {
          this.toggleModifier("animated", true)
          this.hasEnabledAnimations = true
        }

        this.toggleMode(input.value as SearchMode)
      })
    })

    this.syncFromCheckedInput()
  }

  private syncFromCheckedInput() {
    const checked = this.modeInputs.find((i) => i.checked)
    this.toggleMode((checked?.value as SearchMode) || "search")
  }

  private toggleMode(mode: SearchMode) {
    const showDropdown = mode === "dropdown"
    const containerToHide = showDropdown ? this.searchFieldContainer : this.dropdownContainer
    const activeElement = document.activeElement as HTMLElement | null

    if (activeElement && containerToHide.contains(activeElement)) {
      activeElement.blur()
    }

    this.dropdownContainer.classList.toggle("active", showDropdown)
    this.dropdownContainer.classList.toggle("hidden", !showDropdown)
    this.dropdownContainer.setAttribute("aria-hidden", showDropdown ? "false" : "true")
    this.searchFieldContainer.classList.toggle("active", !showDropdown)
    this.searchFieldContainer.classList.toggle("hidden", showDropdown)
    this.searchFieldContainer.setAttribute("aria-hidden", showDropdown ? "true" : "false")
  }
}
